module.exports = __webpack_public_path__ + "static/media/water.8d1046b5.svg";